import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=40021c81"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__